import { LoginContext, User } from '../types';
import { omit } from 'lodash';
import { AUTH_LOGIN_CONTEXT_KEY, AUTH_USERDATA_KEY } from '../constants';

export { AUTH_LOGIN_CONTEXT_KEY } from '../constants';

export const saveUserData = (userData: User) => {
  const userDataNoBrands: User = {
    ...userData,
    loginContexts: userData.loginContexts.map((loginContext: LoginContext) =>
      omit(loginContext, 'brands')
    ),
  };
  localStorage.setItem(AUTH_USERDATA_KEY, JSON.stringify(userDataNoBrands));
};

export const saveToken = (loginContext: LoginContext) => {
  localStorage.setItem(AUTH_LOGIN_CONTEXT_KEY, JSON.stringify(omit(loginContext, 'brands')));
};

// Re-export from lib/react-query-auth to maintain backward compatibility
export { deleteUserData, deleteToken } from 'lib/react-query-auth/utils';

export const getUserData = () => {
  const userDataJson = localStorage.getItem(AUTH_USERDATA_KEY);
  const userData: User | null = userDataJson ? JSON.parse(userDataJson) : null;
  const loginContextJson = localStorage.getItem(AUTH_LOGIN_CONTEXT_KEY);
  const loginContext: LoginContext = loginContextJson ? JSON.parse(loginContextJson) : null;
  return { userData, loginContext };
};
